import { AppSettings } from "@core/types/app-settings.interface";

export const environment: AppSettings = {
  production: true,
  selectEmptyOption: 'Select an option',
  apiBaseUri: 'https://demo.api.thelandlordportal.co.uk',
  loginUri: 'https://demo.api.thelandlordportal.co.uk/api/account/login',
  stripeSettings: {
    pricingTableId: 'prctbl_1Pl7rXRpr2JcH9JNNztNyreu',
    publishableKey: 'pk_test_51PienlRpr2JcH9JNgSYc76JTcK48q7n2BT5uNSduoG87qtE02IYVlmf0ibDwI5mDj5bLlnwzl0F91u4rkgbuZ4oK00cTZlTF7c'
  }
};
